export const hi = {
  tip: "सुझाव",
  fatInputTip: "यदि आप {val}.0 लिखना चाहते हैं तो दशमलव के साथ सटीक मान दर्ज करें या 3 अंकों के साथ {val}0 दर्ज करें।",
  snfInputTip: "यदि आप {val}.0 लिखना चाहते हैं तो दशमलव के साथ सटीक मान दर्ज करें या 3 अंकों के साथ {val}0 दर्ज करें।",
  // Header/Navigation
  // appTitle: "दुधिया: दूध प्रबंधन प्रणाली",
  home: "होम",
  logout: "लॉगआउट",

  // Hire Person
  hirePersonBannerHeading: "क्या आप खुद संग्रह नहीं करना चाहते?",
  hirePersonBannerSubheading: "संग्रह के लिए एक व्यक्ति किराए पर लें",
  hirePersonModalTitle: "संग्रह के लिए व्यक्ति किराए पर लें",
  hirePersonCostEstimate: "लागत अनुमान",
  hirePersonCostEstimateDesc: "मूल्य आमतौर पर ₹500 से ₹3,000-₹4,000 प्रति माह तक होता है, यह औसत दैनिक संग्रह की संख्या और आवश्यक कार्य की मात्रा के आधार पर भिन्न होता है।",
  hirePersonContactNetpy: "दुधिया सहायता से संपर्क करें",
  hirePersonContactNetpyDesc: "एक अनुकूलित उद्धरण प्राप्त करने और अपने क्षेत्र में विश्वसनीय संग्रह कर्मचारियों से जुड़ने के लिए हमसे संपर्क करें।",
  hirePersonCallNetpy: "कॉल NetPy",
  hirePersonWhatsAppNetpy: "व्हाट्सएप NetPy",

  // Dashboard
  dashboard: "डैशबोर्ड",
  dairyName: "डेयरी का नाम",
  walletBalance: "वॉलेट बैलेंस",
  addMoney: "पैसे जोड़ें",
  notAvailable: "उपलब्ध नहीं",

  // Rate Information
  milkRate: "दूध की रेट",
  currentRate: "वर्तमान रेट",
  currentMilkRate: "वर्तमान दूध की रेट",
  editRate: "रेट बदलें",
  rateType: "रेट का प्रकार",
  selectRateType: "रेट प्रकार चुनें",
  submit: "जमा करें",
  submitting: "जमा हो रहा है...",
  save: "सेव करें",
  saving: "सेव हो रहा है...",
  cancel: "रद्द करें",

  // Dashboard Cards
  bulkRateUpdate: "बल्क में दूध का रेट बदलें",
  bulkRateUpdateBtn: "रेट बदलें",
  bulkRateUpdateTooltip: "कई कलेक्शन के लिए दूध की दर बदलें",
  rateSettings: "रेट सेटिंग्स",
  updateRatesForMultipleCollections: "कई कलेक्शन के लिए रेट अपडेट करें",
  configureMilkPricingAndRateTypes: "दूध की कीमत और रेट प्रकार कॉन्फ़िगर करें",
  updateMultipleCollectionsAtOnce: "एक साथ कई कलेक्शन का दूध रेट बदलें",
  previewBeforeApplyingChanges: "बदलाव लागू करने से पहले पूर्वावलोकन करें",
  setCurrentMilkRate: "वर्तमान दूध रेट सेट करें",
  setMilkRateNow: "अपना दूध रेट अभी सेट करें!",
  managePricingParameters: "मूल्य निर्धारण पैरामीटर प्रबंधित करें",
  applyToSpecificDateRanges: "विशिष्ट तिथि सीमाओं पर लागू करें",
  configureRateType: "रेट प्रकार कॉन्फ़िगर करें (FAT+SNF, FAT+CLR, आदि)",

  // Collection Cards
  regularMilkCollections: "नियमित दूध कलेक्शन",
  proportionalCollections: "आनुपातीय कलेक्शन",
  generateDetailedReports: "विस्तृत रिपोर्ट जेनरेट करें",
  proRataCollection: "प्रो-राटा कलेक्शन",
  standardCollection: "स्टैंडर्ड कलेक्शन",
  notAvailableWithKGLitersRateType: "किग्रा/लीटर रेट प्रकार के साथ उपलब्ध नहीं",
  selectCollectionType: "कलेक्शन प्रकार चुनें",
  applyFilter: "फिल्टर लागू करें",
  applying: "लागू हो रहा है...",
  applyRateChanges: "रेट बदलाव लागू करें",

  // Wallet Modal
  addToWallet: "वॉलेट में जोड़ें",
  topUpWalletInstantlyUsingRazorpay: "रेज़रपे का उपयोग करके तुरंत अपना वॉलेट टॉप अप करें",
  quickRecharge: "त्वरित रिचार्ज",
  walletRecharge: "रिचार्ज",

  // Add Money Modal
  moneyAddedToWalletMessage: "सफल भुगतान के बाद 5 मिनट के भीतर धन आपके वॉलेट में जोड़ दिया जाएगा।  ",
  refreshPage: "पेज को रिफ्रेश करें",
  please: " कृपया",
  enterAmount: "राशि दर्ज करें",
  enterValidAmount: "वैध राशि दर्ज करें (₹1 या अधिक)",
  youWillGetExtraOnRecharge: "आपको इस रिचार्ज पर ₹{amount} अतिरिक्त मिलेगा!",
  youWillGet10PercentBonus: "आपको इस रिचार्ज पर ₹{amount} अतिरिक्त मिलेगा!",
  youWillGet5PercentBonus: "आपको इस रिचार्ज पर ₹{amount} अतिरिक्त मिलेगा!",
  continueToPayment: "भुगतान जारी रखें",
  loading: "लोड हो रहा है...",

  // Rate Settings Modal
  saveSettings: "सेटिंग्स सेव करें",
  perKg: "/किग्रा",
  milkRateHeading: "दूध की दर",
  milkRateAndRateSettingsSavedSuccessfully: "दूध रेट ₹{currentRate}/किग्रा और रेट सेटिंग्स सफलतापूर्वक सेव हो गई!",

  // Collections
  addCollection: "बल्क कलेक्शन",
  viewCollections: "कलेक्शन देखें",
  standardCollections: "कलेक्शन",
  proRataCollections: "प्रो-राटा कलेक्शन",
  quickFiltersAndActions: "तेज़ फ़िल्टर और कार्य",
  refineCollectionsAndManageRatesInstantly: "कलेक्शन सुधारें और रेट तुरंत अपडेट करें",
  proRataFiltersAndActions: "प्रो-राटा फ़िल्टर और कार्रवाई",
  targetCollectionsAndUpdateProRataRatesFaster: "कलेक्शन चुनें और प्रोराटा रेट तुरंत अपडेट करें",

  // Supplier Management
  addCustomer: "सप्लायर जोड़ें",
  viewCustomers: "सप्लायर देखें",
  customerName: "सप्लायर का नाम",
  phoneNumber: "फोन नंबर",

  // Reports
  generateReport: "रिपोर्ट बनाएंं",
  reports: "रिपोर्ट",
  generateStandardReport: "रिपोर्ट बनाएंं",
  generateProRataReport: "रिपोर्ट बनाएंं",

  // Wallet
  wallet: "वॉलेट",
  addFunds: "पैसे जोड़ें",
  amount: "राशि",
  paymentSuccessful: "भुगतान सफल! आपका वॉलेट जल्द ही अपडेट हो जाएगा।",
  paymentSuccessfulWithAmount: "✅ भुगतान सफल! ₹{amount} आपके वॉलेट में जोड़ दिया गया।",
  paymentFailed: "भुगतान असफल। कृपया पुनः प्रयास करें।",
  paymentCancelled: "भुगतान रद्द। यदि आप पैसे जोड़ना चाहते हैं तो कृपया पुनः प्रयास करें।",
  paymentSessionTimedOut: "भुगतान समय समाप्त। कृपया जांचें कि भुगतान पूरा हुआ या नहीं।",
  paymentCancelledOrIncomplete: "भुगतान रद्द या अधूरा। कृपया फिर से कोशिश करें।",
  unableToVerifyPaymentStatus: "भुगतान स्थिति सत्यापित करने में असमर्थ। कृपया अपने वॉलेट बैलेंस की जांच करें।",

  // Collection Details
  singleDateShift: "एकल तिथि/शिफ्ट",
  multiDateShift: "बहु तिथि/शिफ्ट",
  date: "तारीख",
  customer: "सप्लायर",
  weight: "वजन",
  fatPercentage: "FAT %",
  snfPercentage: "SNF %",
  fatKg: "FAT किग्रा",
  snfKg: "SNF किग्रा",
  fatRate: "FAT रेट",
  snfRate: "SNF रेट",
  baseSNF: "बेस SNF",
  totalAmount: "कुल राशि",
  finalAmount: "देय राशि",
  avgFat: "औसत FAT",
  avgSnf: "औसत SNF",
  totalQuantity: "कुल मात्रा",
  totalFat: "कुल FAT",
  totalSnf: "कुल SNF",
  totalSolidWeight: "कुल ठोस वजन",

  // Common
  // loading: "लोड हो रहा है...",
  error: "त्रुटि",
  success: "सफलता",
  confirm: "पुष्टि करें",
  edit: "संपादित करें",
  delete: "हटाएं",
  add: "जोड़ें",
  update: "अपडेट करें",
  close: "बंद करें",

  // Units
  kg: "किग्रा",
  currency: "₹",

  // Messages
  loadingInformation: "जानकारी लोड हो रही है...",
  loadingDairyInformation: "डेयरी जानकारी लोड हो रही है...",
  loadingUserInformation: "उपयोगकर्ता जानकारी लोड हो रही है...",
  dairy: "डेयरी",
  balance: "शेष",
  changeType: "प्रकार बदलें",
  processing: "प्रोसेसिंग...",
  submittingCollections: "कलेक्शन सबमिट हो रहे हैं",
  processingCollections: "{total} में से {current} कलेक्शन प्रोसेस हो रहे हैं",
  noDataYet: "अभी तक कोई डेटा नहीं है। कलेक्शन जोड़ना शुरू करने के लिए 'पंक्ति जोड़ें' पर क्लिक करें।",
  loadingRateInformation: "रेट की जानकारी लोड हो रही है...",

  // Footer
  // allRightsReserved: "सर्वाधिकार सुरक्षित",
  poweredBy: "द्वारा संचालित",

  // Login
  login: "लॉगिन",
  enterPhoneNumber: "अपना 10-अंकीय फोन नंबर दर्ज करें",
  verifyOTP: "OTP सत्यापित करें",
  enterOTP: "OTP दर्ज करें",
  changeNumber: "नंबर बदलें",

  // Language Names
  english: "English",
  hindi: "हिन्दी",
  punjabi: "ਪੰਜਾਬੀ",
  kannada: "ಕನ್ನಡ",

  // Bulk Collection
  bulkCollection: "बल्क कलेक्शन",
  prorataBulkCollection: "बल्क कलेक्शन",
  prorataViewCollections: "कलेक्शन देखें",
  bulkCollectionSpreadsheetView: "बल्क कलेक्शन - स्प्रेडशीट देखें",
  backToDashboard: "डैशबोर्ड पर वापस जाएं",
  customerManagement: "सप्लायर प्रबंधन",
  rateConfiguration: "रेट कॉन्फ़िगरेशन",
  changeRates: "रेट बदलें",
  add1Row: "1 पंक्ति जोड़ें",
  add5Rows: "5 पंक्तियां जोड़ें",
  previewSubmit: "पूर्वावलोकन और जमा करें",
  collectionDateEdit: "कलेक्शन तिथि",
  collectionTimeEdit: "कलेक्शन समय",

  // Table Headers
  serialNumber: "#",
  weightKg: "वजन (किग्रा)",
  actions: "क्रियाएं",

  // Form Fields
  searchCustomer: "सप्लायर खोजें",
  time: "समय",
  rate: "रेट (₹)",

  // Options
  morning: "सुबह",
  evening: "शाम",
  cow: "गाय",
  buffalo: "भैंस",
  cowBuffalo: "गाय + भैंस",

  // Shift Filter Options
  allShifts: "सुबह + शाम",
  morningAm: "सुबह",
  eveningPm: "शाम",

  // Actions
  submitAll: "सभी जमा करें",

  // New Customer Modal
  name: "नाम",
  phone: "फोन",
  owner: "मालिक",
  village: "गांव",
  address: "पता",
  enterCustomerName: "सप्लायर का नाम दर्ज करें",
  enterFatherName: "पिता का नाम दर्ज करें",
  enter10DigitPhone: "10-अंकीय फोन नंबर दर्ज करें",
  enterVillageName: "गांव का नाम दर्ज करें",
  enterCompleteAddress: "पूरा पता दर्ज करें",
  saveCustomer: "सप्लायर सेव करें",

  // Messages
  noCollectionsAdded: "अभी तक कोई कलेक्शन नहीं जोड़ा गया है। कलेक्शन जोड़ने के लिए नीचे दिए गए बटन पर क्लिक करें।",
  collectionSubmittedSuccessfully: "कलेक्शन सफलतापूर्वक जमा हो गया!",
  collectionsSubmittedSuccessfully: "कलेक्शन सफलतापूर्वक जमा हो गए!",
  collectionForCustomerSubmitted: "{customer} का कलेक्शन सफलतापूर्वक जमा हो गया!",
  validFatPercentRequired: "वैध Fat प्रतिशत आवश्यक है",
  validWeightRequired: "वैध वजन आवश्यक है",
  validSnfPercentRequired: "वैध snf प्रतिशत आवश्यक है",
  pleaseAddAtLeastOneCollection: "कृपया कम से कम एक कलेक्शन जोड़ें",
  fromCLR: "सीएलआर से",
  noCustomersFound: "कोई सप्लायर नहीं मिला",

  // Placeholders
  egTenPointFive: "जैसे 10.5",
  egThreePointFive: "जैसे 3.5",
  egTwentySevenPointZero: "जैसे 27.0",
  egEightPointFive: "जैसे 8.5",
  egFiftyFivePointZero: "जैसे 55.0",

  // Preview Collections filters and sorting
  searchCustomerOrId: "सप्लायर के नाम या आईडी से खोजें...",
  filterByCustomer: "सप्लायर से खोजें",
  filterByDate: "तारीख से खोजें",
  filterByAnimal: "पशु के अनुसार फिल्टर",
  allAnimals: "सभी पशु",
  newestFirst: "नया पहले",
  oldestFirst: "पुराना पहले",
  changeMilkRate: "दूध की रेट बदलें",
  sortTooltipNewestFirst: "निर्माण समय के अनुसार नया पहले (पुराना पहले करने के लिए बदलें)",
  sortTooltipOldestFirst: "निर्माण समय के अनुसार पुराना पहले (नया पहले करने के लिए बदलें)",
  sortingLabel: "सॉर्टिंग:",
  sortingByCreationTime: "निर्माण समय के अनुसार",

  // Additional translations for BulkCollectionV1
  lowWalletBalance: "कम वॉलेट बैलेंस",
  walletBalanceLowMessage: "आपका वॉलेट बैलेंस ₹50 से कम है। निरंतर सेवा सुनिश्चित करने के लिए कृपया अपने वॉलेट में पैसे जोड़ें।",
  currentBalance: "वर्तमान बैलेंस",
  dismiss: "बंद करें",

  // Pro Rata Collection specific translations

  // Rate Information
  // milkRate: "दूध की रेट (₹)",
  // fatSnf: "Fat + snf",
  // fatClr: "फैट + सीएलआर",
  // litersOnly: "केवल लीटर",

  // Rate Configuration
  rateChart: "रेट चार्ट",
  previewAndSubmit: "पूर्वावलोकन और जमा करें",
  noDataYetClickAddRow: "अभी तक कोई डेटा नहीं है। कलेक्शन जोड़ना शुरू करने के लिए \"पंक्ति जोड़ें\" पर क्लिक करें।",

  // Customer Management
  addNewCustomer: "नया सप्लायर जोड़ें",

  // Collection Form
  animalType: "पशु का प्रकार",
  mixed: "मिश्रित",

  // Add Money Modal
  topUpWalletInstantly: "रेज़रपे का उपयोग करके तुरंत अपना वॉलेट टॉप अप करें",

  // Rate Chart Modal
  fatStepUpRates: "FAT स्टेप-अप रेटें",
  snfStepDownRates: "SNF स्टेप-डाउन रेटें",
  rateAppliesWhenFatGreater: "यह रेट तब लागू होती है जब FAT % स्टेप से अधिक हो",
  rateAppliesWhenSnfLess: "यह रेट तब लागू होती है जब SNF% स्टेप से कम हो",
  step: "स्टेप (%)",
  addStep: "स्टेप जोड़ें",
  fatSnfRatio: "FAT/SNF अनुपात",

  // Change Rates Modal
  baseSNFSetting: "बेस snf सेटिंग",
  clrConversionFactor: "CLR रूपांतरण कारक",
  selectConversionFactor: "सीएलआर से snf फॉर्मूला में उपयोग किया जाने वाला रूपांतरण कारक चुनें",

  // New Customer Modal
  newCustomer: "नया सप्लायर",

  // Messages and Alerts
  deleteConfirmation: "क्या आप वाकई इस कलेक्शन को हटाना चाहते हैं?",
  confirmDelete: "हटाना पुष्ट करें",
  pleaseAllowPopups: "भुगतान पूरा करने के लिए कृपया पॉपअप की अनुमति दें।",
  paymentLinkOpened: "भुगतान लिंक नए टैब में खुला। वहां भुगतान पूरा करें।",
  failedToCreatePaymentLink: "भुगतान लिंक बनाने में असफल। कृपया पुनः प्रयास करें।",

  // Bonus Messages
  bonusMessage5Percent: "आपको इस रिचार्ज पर ₹{amount} अतिरिक्त मिलेगा!",
  bonusMessage10Percent: "आपको इस रिचार्ज पर ₹{amount} अतिरिक्त मिलेगा!",

  // Validation Messages
  customerNameRequired: "सप्लायर का नाम आवश्यक है",

  // Success Messages
  rateTypeUpdatedSuccessfully: "रेट प्रकार सफलतापूर्वक अपडेट हो गया!",
  newCustomerCreatedSuccessfully: "नया सप्लायर {name} सफलतापूर्वक बनाया गया!",

  // Error Messages
  someCollectionsHaveInvalidData: "कुछ कलेक्शन में अमान्य डेटा है। कृपया सभी फ़ील्ड जांचें और पुनः प्रयास करें।",
  failedToSubmitCollection: "{supplier} के लिए कलेक्शन जमा करने में असफल: {error}",
  failedToUpdateMilkRate: "दूध की रेट अपडेट करने में असफल। कृपया पुनः प्रयास करें।",
  failedToUpdateRateType: "रेट प्रकार अपडेट करने में असफल। कृपया पुनः प्रयास करें।",
  failedToCreateCustomer: "सप्लायर बनाने में असफल। कृपया पुनः प्रयास करें।",

  // CLR Validation
  clrValueBelowMinimum: "CLR मान {value} न्यूनतम (13.1) से कम है",
  clrValueAboveMaximum: "CLR मान {value} अधिकतम (34.0) से अधिक है",

  // Warning Messages
  warningFatPercentBelowMin: "चेतावनी: Fat % न्यूनतम {min}% से कम",
  warningFatPercentAboveMax: "चेतावनी: Fat % अधिकतम {max}% से अधिक",
  warningSnfPercentBelowMin: "चेतावनी: snf % न्यूनतम {min}% से कम",
  warningSnfPercentAboveMax: "चेतावनी: snf % अधिकतम {max}% से अधिक",
  warningClrBelowMin: "चेतावनी: CLR मान {min} से कम",
  warningClrAboveMax: "चेतावनी: CLR मान {max} से अधिक",
  warningFatPercentBelowMinRaw: "चेतावनी: Fat प्रतिशत {min}% से कम",
  warningFatPercentAboveMaxRaw: "चेतावनी: Fat प्रतिशत {max}% से अधिक",
  warningSnfPercentBelowMinRaw: "चेतावनी: snf प्रतिशत {min}% से कम",
  warningSnfPercentAboveMaxRaw: "चेतावनी: snf प्रतिशत {max}% से अधिक",

  // Confirmation Messages
  confirmDeletion: "हटाने की पुष्टि करें",
  areYouSureDeleteRow: "क्या आप वाकई इस पंक्ति को हटाना चाहते हैं?",
  actionCannotBeUndone: "यह क्रिया वापस नहीं की जा सकती।",
  deleteThisRow: "इस पंक्ति को हटाएं",
  deleteCollectionRow: "कलेक्शन पंक्ति हटाएं",
  rowWillBePermanentlyDeleted: "इस पंक्ति में डेटा है जो स्थायी रूप से हटा दिया जाएगा",
  areYouSureProceedDeletion: "क्या आप वाकई हटाने के साथ आगे बढ़ना चाहते हैं?",

  // Low Percentage Warning
  lowPercentageValue: "कम प्रतिशत मान",
  enteredValueLessThan: "आपने {field} के लिए {min}% से कम मान दर्ज किया है",
  enteredProcessed: "दर्ज: {entered} → प्रसंस्कृत: {processed}%",
  areYouSureProceedValue: "क्या आप वाकई इस मान के साथ आगे बढ़ना चाहते हैं?",

  // Preview Modal
  pleaseReviewBeforeSave: "कृपया सहेजने से पहले संपादित कलेक्शन की समीक्षा करें:",
  totalRecords: "कुल रिकॉर्ड:",
  confirmSubmit: "पुष्टि करें और सबमिट करें",

  // Add Money Modal
  offers: "ऑफर",
  rechargeOffers: "रिचार्ज ऑफर",
  getExtraBonus: "रिचार्ज पर अतिरिक्त बोनस पाएं",
  starterBonus: "स्टार्टर बोनस",
  premiumBonus: "प्रीमियम बोनस",
  bestValue: "सबसे अच्छा मूल्य",

  // New Supplier Modal
  pleaseFillCustomerDetails: "कृपया सप्लायर विवरण भरें। * से चिह्नित फ़ील्ड आवश्यक हैं।",
  createCustomer: "सप्लायर बनाएं",
  savingCustomer: "सेव हो रहा है...",

  // Preview Collections Modals
  confirmDeleteCollection: "हटाने की पुष्टि करें",
  areYouSureDeleteCollection: "क्या आप वाकई इस कलेक्शन को हटाना चाहते हैं?",
  dateTime: "तारीख और समय",
  deleting: "हटाया जा रहा है...",
  deleteSuccess: "कलेक्शन सफलतापूर्वक हटा दिया गया",
  collectionDeletedSuccessfully: "कलेक्शन सफलतापूर्वक हटा दिया गया!",
  deleteFailed: "कलेक्शन हटाने में विफल। कृपया पुनः प्रयास करें।",
  loadCollectionsFailed: "कलेक्शन लोड करने में विफल। कृपया बाद में पुनः प्रयास करें।",
  loadCustomersFailed: "सप्लायरों को लोड करने में विफल। कृपया बाद में पुनः प्रयास करें।",
  pleaseSelectDate: "कृपया एक तारीख चुनें",
  pleaseSelectBothDates: "कृपया दोनों तारीखें चुनें",
  toDateCannotBeEarlier: "प्रारंभ तारीख से पहले की तारीख नहीं हो सकती",

  // Bulk Update Modal
  bulkUpdateRateBaseSnf: "दूध और बेस SNF अपडेट करें",
  updatingCollections: "{count} कलेक्शन अपडेट किए जा रहे हैं",
  dateRange: "तारीख सीमा",
  allDates: "सभी तारीखें",
  newMilkRatePerKg: "नई दूध दर (₹/किलो):",
  newBaseSnfPercent: "नई बेस SNF (%):",
  updateCollections: "कलेक्शन अपडेट करें",
  updating: "अपडेट हो रहा है...",

  // Milk Rate Preview Modal
  previewMilkRateCalculations: "दूध दर गणना का पूर्वावलोकन",
  collectionsOnDate: "{date} को कलेक्शन",
  collectionsFromToDate: "{fromDate} से {toDate} तक कलेक्शन",
  milkRateLabel: "दूध दर",
  solid: "ठोस",

  // Filter Modal
  dateRangeLabel: "तारीख सीमा",

  // Supplier Selection Modal
  searchCustomers: "सप्लायर खोजें...",

  // Bulk Update Confirmation Modal
  confirmBulkUpdate: "थोक अपडेट की पुष्टि करें",
  areYouSureApplyBulkChanges: "क्या आप वाकई ये थोक बदलाव लागू करना चाहते हैं?",
  collectionsToUpdate: "अपडेट होने वाले कलेक्शन",
  newMilkRate: "नई दूध दर (₹/किग्रा)",
  enterNewMilkRate: "नई दूध दर दर्ज करें",
  newSnfPercentage: "नई SNF प्रतिशत: {percentage}%",
  newClr: "नई CLR: {clr}",
  updatingCollectionsCount: "{count} संग्रह अपडेट हो रहे हैं",
  newRate: "नई दर",
  newAmount: "नई राशि",
  confirmAndUpdate: "पुष्टि करें और अपडेट करें",

  // Final Submit Confirmation Modal
  importantConfirmation: "महत्वपूर्ण पुष्टि",
  irreversibleChangesWarning: "अपरिवर्तनीय परिवर्तन चेतावनी",
  pleaseBeAware: "कृपया ध्यान दें:",
  irreversibleChangesWarningText: "एक बार आप सबमिट बटन पर क्लिक करें, इन परिवर्तनों को पिछली स्थिति में वापस नहीं किया जा सकता। सभी प्रभावित संग्रह स्थायी रूप से नए मानों के साथ अपडेट किए जाएंगे।",
  areYouAbsolutelySureYouWantToProceed: "क्या आप वाकई आगे बढ़ना चाहते हैं?",
  submitChanges: "परिवर्तन सबमिट करें",

  // Report Types
  fullReport: "पूर्ण रिपोर्ट",
  purchaseReportDayWise: "खरीद रिपोर्ट - दिन अनुसार",
  purchaseSummarySupplierWise: "खरीद सारांश - सप्लायर अनुसार",
  allSupplierBill: "सभी सप्लायर बिल",
  supplierBillsPro: "सप्लायर बिल (प्रो-राटा)",
  supplierBills: "सप्लायर बिल ",


  // Pro-Rata Report Types
  fullReportPro: "पूर्ण रिपोर्ट (प्रो-राटा)",
  purchaseReportDayWisePro: "खरीद रिपोर्ट - दिन अनुसार (प्रो-राटा)",
  purchaseSummarySupplierWisePro: "खरीद सारांश - सप्लायर अनुसार (प्रो-राटा)",
  allSupplierBillPro: "सभी सप्लायर बिल (प्रो-राटा)",
  supplierBillsPro: "सप्लायर बिल (प्रो-राटा)",
  viewCompleteCollectionReport: "पूर्ण कलेक्शन रिपोर्ट देखें",
  viewCollectionsByDate: "तारीख के अनुसार कलेक्शन देखें",
  viewCollectionsAsPerSupplier: "सप्लायर के अनुसार कलेक्शन देखें",
  viewComprehensiveSupplierBills: "व्यापक सप्लायर बिल देखें",
  viewIndividualSupplierBills: "व्यक्तिगत सप्लायर बिल देखें",

  // Additional Labels
  selectReportType: "रिपोर्ट प्रकार चुनें",
  selectReportTypeProRata: "रिपोर्ट प्रकार चुनें (प्रो-राटा)",
  pleaseSelectBothStartAndEndDates: "कृपया प्रारंभ और अंतिम दोनों तारीखें चुनें",
  invalidReportTypeSelected: "अमान्य रिपोर्ट प्रकार चुना गया",
  failedToGenerateReport: "रिपोर्ट बनाने में असफल",
  failedToLoadSuppliers: "सप्लायर लोड करने में असफल",
  failedToUpdateSupplierInformation: "सप्लायर जानकारी अपडेट करने में असफल",
  pleaseSelectDateRangeForReport: "रिपोर्ट के लिए तारीख सीमा चुनें",
  noDataFoundForTheSelectedSupplierInTheSelectedDateRange: "चयनित तारीख सीमा में चयनित सप्लायर के लिए कोई डेटा नहीं मिला",
  failedToGenerateSupplierReport: "सप्लायर रिपोर्ट बनाने में असफल",
  failedToGenerateProRataSupplierReport: "प्रो-राटा सप्लायर रिपोर्ट बनाने में असफल",

  // Month Names
  january: "जनवरी",
  february: "फरवरी",
  march: "मार्च",
  april: "अप्रैल",
  may: "मई",
  june: "जून",
  july: "जुलाई",
  august: "अगस्त",
  september: "सितंबर",
  october: "अक्टूबर",
  november: "नवंबर",
  december: "दिसंबर",

  // Additional missing keys
  includeMilkRateBRateColumn: "दूध दर (बी-रेट) कॉलम शामिल करें",
  backToReportSelection: "रिपोर्ट चयन पर वापस जाएं",
  editSupplier: "सप्लायर",
  databaseId: "डेटाबेस आईडी",
  customerId: "ग्राहक आईडी",
  notSpecified: "उपलब्ध नहीं",
  id: "आईडी",

  // Warning and Success Messages
  milkRateUpdatedSuccessfully: "दूध की दर सफलतापूर्वक अपडेट की गई!",
  errorSavingMilkRatePleaseTryAgain: "दूध की दर सेव करने में त्रुटि। कृपया फिर से प्रयास करें।",
  rateSettingsSavedSuccessfully: "दर सेटिंग्स सफलतापूर्वक सेव की गई!",
  errorSavingMilkRateAndRateSettingsPleaseTryAgain: "दूध की दर और दर सेटिंग्स सेव करने में त्रुटि। कृपया फिर से प्रयास करें।",
  rateChartLoadedSuccessfully: "रेट चार्ट सफलतापूर्वक लोड हुआ",
  paymentLinkOpenedInNewTabCompletePaymentThere: "भुगतान लिंक नए टैब में खोली गई। वहां भुगतान पूरा करें।",
  paymentSuccessfulYourWalletWillBeUpdatedShortly: "✅ भुगतान सफल! आपका वॉलेट जल्द ही अपडेट कर दिया जाएगा।",
  individualMilkRateSavedSuccessfullyProRataCollection: "व्यक्तिगत दूध दर सफलतापूर्वक सेव की गई (प्रो-राटा कलेक्शन)",
  pleaseEnterAtLeastMilkRateSnfOrClrToUpdate: "कृपया कम से कम दूध की दर, SNF प्रतिशत, या CLR दर्ज करें",
  walletBalanceBelowFifty: "आपका वॉलेट बैलेंस ₹50 से कम है। किसी भी सेवा व्यवधान से बचने के लिए कृपया तुरंत धनराशि जोड़ें।",
  closeAddMoneyModal: "पैसे जोड़ने वाला मोडल बंद करें",

  // Milk Rate Preview Modal
  bulkEditCollections: "बल्क एडिट कलेक्शन",
  collectionsOn: "तारीख पर कलेक्शन",
  items: "आइटम",
  clrConversion: "CLR रूपांतरण",
  mix: "गाय + भैंस",
  baseSnf: "BASE SNF",
  totalAmt: "कुल राशि",
  finalAmt: "देय राशि",
  applyBulkChanges: "बल्क परिवर्तन लागू करें",

  // Milk Rate Date Selection Modal
  filterCollectionsForMilkRateUpdate: "दूध दर अपडेट के लिए कलेक्शन फ़िल्टर करें",

  // Rate Settings Modal
  changeFatSnfRatio: "FAT/SNF अनुपात बदलें",
  changeBaseSNF: "BASE SNF बदलें",
  changeClrConversionFactor: "CLR Conversion Factor बदलें",
  areYouSureChangeFatSnfRatioTo: "क्या आप वाकई FAT/SNF अनुपात को {value} में बदलना चाहते हैं?",
  areYouSureChangeBaseSNFTo: "क्या आप वाकई BASE SNF को {value} में बदलना चाहते हैं?",
  areYouSureChangeClrConversionFactorTo: "क्या आप वाकई CLR Conversion Factor को {value} में बदलना चाहते हैं?",
  thisFatSnfRatioWillBeUsed: "यह FAT/SNF अनुपात गणनाओं के लिए उपयोग किया जाएगा।",
  thisBaseSNFWillBeUsed: "यह BASE SNF गणनाओं के लिए उपयोग किया जाएगा।",
  thisClrConversionFactorWillBeUsed: "यह CLR Conversion Factor गणनाओं के लिए उपयोग किया जाएगा।",
  changeBaseSnf: "बेस SNF बदलें",
  confirmChangeBaseSnf: "क्या आप वाकई बेस SNF को {value} में बदलना चाहते हैं?",
  baseSnfWillBeUsedForCalculations: "यह बेस SNF गणनाओं के लिए उपयोग किया जाएगा।",
  confirmChangeRateType: "क्या आप वाकई रेट प्रकार को {value} में बदलना चाहते हैं?",
  confirmChangeFatSnfRatio: "क्या आप वाकई FAT/SNF अनुपात को {value} में बदलना चाहते हैं?",
  confirmChangeClrConversionFactor: "क्या आप वाकई CLR रूपांतरण कारक को {value} में बदलना चाहते हैं?",

  // New Customer Modal
  fathersName: "पिता का नाम",
  enter10DigitPhoneNumber: "10-अंकीय फोन नंबर दर्ज करें",

  // Rate Settings Card
  configureYourMilkCalculationParameters: "दूध गणना पैरामीटर्स को कॉन्फिगर करें",
  fatAndSNF: "FAT & SNF",
  fixedRate: "निश्चित दर",

  // Dairy & Owner Information Card
  dairyAndOwnerInfo: "डेयरी और मालिक की जानकारी",
  yourDairyAndContactDetails: "आपकी डेयरी और संपर्क विवरण",
  ownerName: "मालिक का नाम",

  // Pro Rata Collection Component
  proRata: "प्रो राटा",
  proRataBadge: "प्रो राटा",
  set: "सेट करें",
  status: "स्थिति",
  setTheRateChart: "रेट चार्ट सेट करें",
  fatStepUp: "Fat स्टेप-अप",
  snfStepDown: "SNF स्टेप-डाउन",
  notConfigured: "कॉन्फ़िगर नहीं किया गया",
  proRataStatus: "प्रो-राटा स्थिति",
  active: "सक्रिय",
  rateChartRequired: "रेट चार्ट आवश्यक",
  pleaseSetUpYourRateChartFirst: "कृपया कलेक्शन जोड़ने से पहले अपना रेट चार्ट सेट करें। यह उचित प्रो-राटा गणना के लिए आवश्यक है।",
  setUpRateChart: "रेट चार्ट सेट करें",

  // Edit Collection Modal Labels
  editCollection: "कलेक्शन संपादित करें",
  supplier: "सप्लायर",
  backToEdit: "संपादन पर वापस जाएं",
  previewChanges: "बदलाव देखें",
  confirmSave: "पुष्टि करें और सहेजें",

  // Edit Supplier Modal
  selectSupplierPro: "सप्लायर चुनें (प्रो-राटा)",
  selectSupplier: "सप्लायर चुनें ",

  searchSuppliers: "सप्लायर खोजें...",
  noSuppliersFound: "आपकी खोज से मेल खाने वाले कोई सप्लायर नहीं मिले।",
  typeToSearchSuppliers: "सप्लायर खोजने के लिए टाइप करें...",
  nameRequired: "नाम *",
  enterSupplierName: "सप्लायर का नाम दर्ज करें",
  backToList: "सूची पर वापस जाएं",
  updateSupplier: "सप्लायर अपडेट करें",

  // Preview Collections Modal
  pleaseReviewCollections: "सबमिट करने से पहले कृपया निम्नलिखित संग्रहों की समीक्षा करें:",
  confirmAndSubmit: "पुष्टि करें और सबमिट करें",

  // Customer Filter Modal
  searchSuppliersPlaceholder: "सप्लायर खोजें...",

  // Date Filter Modal
  fromDate: "दिनांक से:",
  toDate: "दिनांक तक:",

  // Milk Rate Update Modal

  // Bulk Update Rate & Base SNF
  bulkUpdateRateAndBaseSNF: "दूध और SNF बदलें",

  // Bulk Update Modal
  newBaseSNF: "नई बेस SNF (%)",
  enterNewBaseSNF: "नई बेस SNF दर्ज करें",

  // Bulk Update Rate & SNF
  bulkUpdateRateAndSnf: "दूध और SNF अपडेट करें",
  enterNewBaseSnf: "नई बेस SNF दर्ज करें",

  // Supplier Details Modal
  supplierID: "सप्लायर ID",
  customerID: "सप्लायर ID",
  supplierInformation: "सप्लायर जानकारी",
  editSupplierInfo: "सप्लायर जानकारी संपादित करें",
  downloadReport: "रिपोर्ट डाउनलोड करें",
  proRataCollectionsModal: "प्रो राटा कलेक्शन",
  rechargeBonusMessage: "इस रिचार्ज पर आपको ₹100.00 अतिरिक्त मिलेंगे!",
  rechargeBonusMessage10Percent: "इस रिचार्ज पर आपको ₹{amount} अतिरिक्त मिलेंगे!",
  rechargeBonusMessage5Percent: "इस रिचार्ज पर आपको ₹{amount} अतिरिक्त मिलेंगे!",
  example500Recharge: "उदाहरण: ₹500 रिचार्ज = वॉलेट में ₹525",
  example1000Recharge: "उदाहरण: ₹1000 रिचार्ज = वॉलेट में ₹1100",
  // Excel Table Headers
  shift: "शिफ्ट",
  animal: "जानवर",
  // Customer Search Dropdown
  searchSupplier: "सप्लायर खोजें...",
  noSupplierFound: "कोई सप्लायर नहीं मिले",
  noId: "कोई ID नहीं",
  selectCustomer: "ग्राहक चुनें",
  loadingCollections: "संग्रह लोड हो रहे हैं...",
  loadMore: "और लोड करें",
  collectionSummary: "संग्रह सारांश",
  noCollectionsFound: "कोई संग्रह नहीं मिले।",
  // Table Headers
  sNo: "क्र.सं.",
  dateAndShift: "तिथि और शिफ्ट",
  date: "तिथि",
  name: "नाम",
  qtyKg: "मात्रा (किग्रा)",
  fatPercent: "FAT %",
  snfPercent: "SNF %",
  clr: "CLR",
  fatKg: "FAT (किग्रा)",
  snfKg: "SNF (किग्रा)",
  fatRate: "FAT दर",
  snfRate: "SNF दर",
  fatStepUp: "FAT स्टेप अप",
  snfStepDown: "SNF स्टेप डाउन",
  bRate: "B दर",
  rate: "दर",
  milkRate: "दूध दर",
  baseSnf: "बेस SNF",
  amount: "राशि",
  actions: "एक्शन",
  retry: "फिर से कोशिश करें",
  thisBulkUpdateCannotBeUndone: "चेतावनी: यह क्रिया स्थायी है और इसे वापस नहीं किया जा सकता।",
  thisActionCannotBeUndone: "यह थोक अपडेट पूर्ववत नहीं किया जा सकता है।",
  addNewSupplier: "नया सप्लायर जोड़ें",
  // Pro-rata Calculation Note
  proRataCalculationNote: "* प्रो-राटा गणना तब लागू होता है जब वसा% > 6.5. दर सूत्र: बेस दर + ((वसा%-6.5)×{fatStepUpRate}) + ((SNF%-9)×{snfStepDownRate})",
  fatSnfRatioNote: "Fat/SNF अनुपात: {ratio} - Fat दर की गणना के लिए ({fatPercent}% दर / 6.5) और SNF दर की गणना के लिए ({snfPercent}% दर / बेस SNF) का उपयोग किया जाता है",
  updateRate: "दर अपडेट करें",
  // Offers Modal
  starterBonusRange: "₹500 - ₹999",
  premiumBonusRange: "₹1000+",
  getExtraBonusOnRecharge: "रिचार्ज पर अतिरिक्त बोनस पाएं",
  getExtra5PercentBonus: "अतिरिक्त 5% बोनस पाएं",
  addBetween500And999: "₹500 - ₹999 के रिचार्ज पर",
  getExtra10PercentBonus: "अतिरिक्त 10% बोनस पाएं",
  add1000OrMore: "₹1000 या अधिक के रिचार्ज पर",
  highPercentageValue: "अधिक प्रतिशत मौल्य",
  enteredValueGreaterThan: "{field} मूल्य {max}% से अधिक दर्ज की है",
  noChangeValue: "नहीं, मूल्य बदलें",
  yesKeepValue: "हाँ, मूल्य रखें",
  // Submission Loading Overlay
  submittingCollectionsToServer: "सर्वर को संग्रह जमा कर रहे हैं...",
  progress: "प्रगति: {progress} की {total} संग्रह",
  // Customer Dropdown and Table Headers
  litersOnly: "लीटर",
  apply: "लागू करें",

  // Active Filters Summary
  activeFilters: "सक्रिय फ़िल्टर:",
  showingCollectionsFor: "{name} के लिए संग्रह दिखा रहे हैं",
  showingCollectionsForOn: "{name} के लिए {date} को संग्रह दिखा रहे हैं",
  showingCollectionsForFromTo: "{name} के लिए {fromDate} से {toDate} तक संग्रह दिखा रहे हैं",
  showingAllCollectionsOn: "सभी संग्रह {date} को दिखा रहे हैं",
  showingAllCollectionsFromTo: "सभी संग्रह {fromDate} से {toDate} तक दिखा रहे हैं",
  sorting: "छंटनी:",
  byCreationTime: "निर्माण समय के अनुसार",
  clearSupplier: "सप्लायर हटाएं",
  clearDates: "तिथियां हटाएं",

  // Support Modal
  contactSupport: "संपर्क सहायता",
  whatsappSupport: "व्हाट्सएप सहायता",
  callSupport: "कॉल सहायता",
  supportNumber: "+91 7454 860 294",

  // Bulk Collection Support Section
  havingTroubleAddingMoney: "पैसे जोड़ने में परेशानी हो रही है?",
  contactUs: "संपर्क करें",

  // Offers Support Section
  needHelpWithOffers: "ऑफ़र्स के साथ मदद चाहिए?",

  // Navbar Support Button
  support: "सहायता",

  // Toast Messages for Pro-Rata Collections
  collectionUpdatedSuccessfully: "कलेक्शन सफलतापूर्वक अपडेट हो गया!",
  updatedProRataCollectionsWithMilkRate: "{successful} प्रो-राटा कलेक्शन दूध दर के साथ अपडेट किए गए। {failed} कलेक्शन अपडेट करने में असफल।",
  successfullyUpdatedProRataCollectionsWithMilkRate: "{count} प्रो-राटा कलेक्शन दूध दर {rate} के साथ सफलतापूर्वक अपडेट किए गए।",
  successfullyUpdatedProRataCollections: "{count} प्रो-राटा कलेक्शन सफलतापूर्वक अपडेट किए गए।",
  noProRataCollectionsFoundToUpdate: "अपडेट करने के लिए कोई प्रो-राटा कलेक्शन नहीं मिला।",
  failedToApplyMilkRatesAndBaseSnf: "दूध दर और बेस SNF लागू करने में असफल। कृपया फिर से प्रयास करें।",
  failedToDeleteCollection: "कलेक्शन हटाने में असफल। कृपया फिर से प्रयास करें।",
  failedToUpdateCollections: "कलेक्शन अपडेट करने में असफल। कृपया फिर से प्रयास करें।",

  // Validation Error Messages
  collectionDateRequired: "कलेक्शन तिथि आवश्यक है",
  snfPercentCannotExceed15: "SNF प्रतिशत 15% से अधिक नहीं हो सकता",
  clrValueInvalid: "CLR मान \"{value}\" अमान्य है। कम से कम 2 अंक होने चाहिए (जैसे 27.50)",

  // Milk Rate Date Selection Modal
  singleDate: "एकल तिथि",
  selectDate: "तिथि सीमा",

  // Customer Validation Error Messages
  customerNotFoundInSystem: "ग्राहक सिस्टम में नहीं मिला",
  pleaseSelectValidCustomerBeforeContinuing: "कृपया जारी रखने से पहले एक वैध ग्राहक चुनें",
  failedToVerifyCustomer: "ग्राहक को सत्यापित करने में असफल। कृपया फिर से प्रयास करें।",
  customerSelectionIsRequired: "ग्राहक चयन आवश्यक है",
  pleaseSelectValidCustomerBeforeSaving: "कृपया सहेजने से पहले एक वैध ग्राहक चुनें",
  pleaseEnterValidMilkRate: "कृपया वैध दूध दर दर्ज करें",
  noProRataCollectionsFoundForSelectedDateRange: "चयनित तिथि सीमा के लिए कोई प्रो-राटा कलेक्शन नहीं मिला",
  failedToLoadProRataCollectionsForPreview: "पूर्वावलोकन के लिए प्रो-राटा कलेक्शन लोड करने में असफल। कृपया फिर से प्रयास करें।",

  // Bulk Update Error Messages
  pleaseEnterAtLeastOneValueToUpdate: "कृपया अपडेट करने के लिए कम से कम एक मान दर्ज करें",
  noCollectionsFoundToUpdate: "अपडेट करने के लिए कोई कलेक्शन नहीं मिला",

  // Bulk Update Result Messages
  collectionReachedMaximumEditLimit: "कलेक्शन {id} अधिकतम संपादन सीमा तक पहुंच गया है ({message})",
  failedToUpdateCollection: "कलेक्शन {id} अपडेट करने में असफल: {message}",
  bulkUpdateFailed: "बल्क अपडेट असफल। कृपया फिर से प्रयास करें।",
  collectionReachedMaximumEditLimitWithCount: "कलेक्शन {id} अधिकतम संपादन सीमा तक पहुंच गया है ({editCount}/2)",
  invalidCollectionSelectedForDeletion: "हटाने के लिए अमान्य कलेक्शन चुना गया",
  updatedCollectionsWithMilkRatePartially: "{successful} कलेक्शन दूध की दर के साथ अपडेट किए गए। {failed} कलेक्शन अपडेट करने में असफल।",
  successfullyUpdatedCollectionsWithMilkRate: "{count} कलेक्शन दूध की दर {rate} के साथ सफलतापूर्वक अपडेट किए गए।",
  successfullyUpdatedCollections: "{count} कलेक्शन सफलतापूर्वक अपडेट किए गए।",
  successfullyUpdatedProRataCollectionsWithRateChart: "{count} प्रो-रेटा कलेक्शन रेट चार्ट के साथ सफलतापूर्वक अपडेट किए गए।",
  noCollectionsWereUpdated: "कोई कलेक्शन अपडेट नहीं किए गए। कृपया जांचें कि कलेक्शन मौजूद हैं और फिर से प्रयास करें।",
  rateChartFunctionalityWillBeImplementedSoon: "दर चार्ट कार्यक्षमता जल्द ही लागू की जाएगी",
  pleaseEnterAValidMilkRate: "कृपया एक वैध दूध दर दर्ज करें",
  noCollectionsFoundForTheSelectedDateRange: "चयनित तिथि सीमा के लिए कोई कलेक्शन नहीं मिला",
  failedToLoadCollectionsForPreview: "पूर्वावलोकन के लिए कलेक्शन लोड करने में असफल। कृपया फिर से प्रयास करें।",
  failedToApplyMilkRates: "दूध की दरें लागू करने में असफल। कृपया फिर से प्रयास करें।",
  pleaseSelectADateForFilter: "कृपया एक तिथि चुनें",
  pleaseSelectBothFromAndToDatesForFilter: "कृपया दोनों प्रारंभ और अंतिम तिथियां चुनें",
  toDateCannotBeEarlierThanFromDateForFilter: "अंतिम तिथि प्रारंभ तिथि से पहले नहीं हो सकती",
  successfullyUpdatedCollectionsWithAccurateAmounts: "✅ {updatedCount} कलेक्शन को सटीक राशि के साथ सफलतापूर्वक अपडेट किया गया।\n❌ {errorCount} कलेक्शन अपडेट करने में असफल।\n\nरिपोर्ट अब सही राशियां दिखाएंगे!",
  errorFixingReportAmounts: "❌ रिपोर्ट राशियों को ठीक करने में त्रुटि। कृपया फिर से प्रयास करें।",
  confirmUpdateAllCollectionsWithAccurateAmounts: "यह सभी कलेक्शन को सटीक राशि के साथ अपडेट करेगा। क्या आप निश्चित हैं?",
  failedToLoadCollections: "कलेक्शन लोड करने में विफल। कृपया बाद में फिर से प्रयास करें।",
  failedToLoadCollectionsForCustomerOnDate: "{customerName} के लिए {date} को कलेक्शन लोड करने में विफल।",
  failedToLoadCollectionsForCustomerBetweenDates: "{customerName} के लिए {fromDate} और {toDate} के बीच कलेक्शन लोड करने में विफल।",
  failedToLoadCollectionsForCustomer: "{customerName} के लिए कलेक्शन लोड करने में विफल।",
  failedToLoadCollectionsOnDate: "{date} को कलेक्शन लोड करने में विफल।",
  failedToLoadCollectionsBetweenDates: "{fromDate} और {toDate} के बीच कलेक्शन लोड करने में विफल।",
  failedToGeneratePreview: "Preview बनाने में विफल। कृपया पुनः प्रयास करें।",
  failedToApplyBulkUpdates: "बल्क अपडेट लागू करने में असफल। कृपया फिर से प्रयास करें।",
  updatedCollectionsWithFieldsPartially: "{successful} कलेक्शन को {fieldsText} के साथ अपडेट किया। {failed} कलेक्शन अपडेट करने में असफल।",
  successfullyUpdatedCollectionsWithFields: "{successful} कलेक्शन को {fieldsText} के साथ सफलतापूर्वक अपडेट किया।",
  noCollectionsFoundForSelectedDateRangeAndCollectionType: "चयनित तिथि सीमा और कलेक्शन प्रकार के लिए कोई कलेक्शन नहीं मिला",
  noStandardCollectionsFoundInDateRange: "चयनित तिथि सीमा में कोई मानक कलेक्शन नहीं मिला",
  errorSavingRateSettings: "दर सेटिंग्स सहेजने में त्रुटि। कृपया फिर से प्रयास करें।",
  errorSavingMilkRateAndRateSettings: "दूध की दर और दर सेटिंग्स सहेजने में त्रुटि। कृपया फिर से प्रयास करें।",
  snfStepMustBeBetween7And12: "SNF स्टेप 7% और 12% के बीच होना चाहिए",
  snfStepMustBeLessThanPreviousSteps: "SNF स्टेप पिछले स्टेप्स से कम होना चाहिए",
  fatStepCannotBeGreaterThan12: "Fat step 12% से अधिक नहीं हो सकता",
  fatStepMustBeGreaterThanPreviousSteps: "Fat step पिछले steps से अधिक होना चाहिए",
  pleaseEnterAtLeastOneValidStep: "कृपया Fat Step-up Rates या SNF Step-down Rates में कम से कम एक वैध step और rate दर्ज करें",
  milkRateUpdatedToXSuccessfully: "दूध की दर ₹{rate}/L पर सफलतापूर्वक अपडेट की गई।",
  supplierXUpdatedSuccessfully: "सप्लायर {name} सफलतापूर्वक अपडेट किया गया!",
  failedToUpdateSupplier: "सप्लायर अपडेट करने में असफल। कृपया फिर से प्रयास करें।",
  supplierNameIsRequired: "सप्लायर का नाम आवश्यक है",
  rateTypeAutoSavedSuccessfully: "रेट टाइप ऑटो-सेव सफलतापूर्वक!",
  failedToAutoSaveRateType: "रेट टाइप ऑटो-सेव करने में असफल। कृपया सबमिट बटन दबाएं।",
  snfPercentIsRequired: "SNF प्रतिशत आवश्यक है",
  validSnfPercentIsRequired: "वैध SNF प्रतिशत आवश्यक है",
  snfPercentMustBeAtLeast4: "SNF प्रतिशत कम से कम 4.0% होना चाहिए",
  snfPercentCannotExceed11: "SNF प्रतिशत 11.0% से अधिक नहीं हो सकता",
  clrIsRequired: "CLR आवश्यक है",
  validClrIsRequired: "वैध CLR आवश्यक है",
  clrValueInvalidMustHaveAtLeast2Digits: "CLR मान \"{value}\" अमान्य है। कम से कम 2 अंक होने चाहिए (जैसे 27.50)",
  validFatPercentIsRequired: "वैध वसा प्रतिशत आवश्यक है",
  fatPercentMustBeAtLeast2: "वसा प्रतिशत कम से कम 2.00% होना चाहिए",
  validWeightIsRequired: "वैध वजन आवश्यक है",
  milkRateXAndRateSettingsSavedSuccessfully: "दूध की दर ₹{rate}/kg और दर सेटिंग्स सफलतापूर्वक सहेजी गईं!",

  // Rate Chart Messages
  rateChartSavedSuccessfully: "रेट चार्ट सफलतापूर्वक सहेजा गया!",
  errorSavingRateChart: "रेट चार्ट सहेजने में त्रुटि: {message}",
  errorSavingFatSnfRatio: "FAT/SNF अनुपात सहेजने में त्रुटि:",

  // Dairy Logo
  dairyLogo: "डेयरी लोगो",
  logoNotSet: "कोई लोगो सेट नहीं है",
  logoUpload: "लोगो अपलोड करें",
  logoReplace: "लोगो बदलें",
  logoRemove: "लोगो हटाएं",
  logoSelectFile: "कृपया पहले लोगो फ़ाइल चुनें।",
  logoMustBePngJpgWebp: "लोगो PNG, JPG, या WebP इमेज होनी चाहिए।",
  logoMustBe2MbOrSmaller: "लोगो 2 MB या उससे छोटी होनी चाहिए।",
  logoUploadValidImage: "कृपया एक वैध PNG, JPG, या WebP इमेज अपलोड करें।",
  logoHint: "आपका लोगो हर PDF रिपोर्ट के ऊपरी-बाएं कोने में दिखाई देगा। PNG, JPG, या WebP, अधिकतम 2 MB।",
  logoUpdatedSuccessfully: "लोगो सफलतापूर्वक अपडेट हुआ!",
  logoRemovedSuccessfully: "लोगो सफलतापूर्वक हटाया गया!",
  logoUploadFailed: "लोगो अपलोड करने में विफल। कृपया फिर से प्रयास करें।",
  logoRemoveFailed: "लोगो हटाने में विफल। कृपया फिर से प्रयास करें।",
  logoRemoveConfirmMessage: "क्या आप वाकई अपना डेयरी लोगो हटाना चाहते हैं?",
  logoChangeButton: "लोगो बदलें",
};
